import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { useCompany } from "../../Contexts/CompanyContext";

// Custom Pin Icon
const customIcon = new L.Icon({
  iconUrl: "asset/images/icons/pin.png",
  iconSize: [100, 60],
});

const MapView = () => {
  const { location } = useCompany();

  const lat = location?.latitude || 0;
  const lng = location?.longitude || 0;

  // Don't render the map if coordinates are not set
  if (!lat && !lng) return null;

  return (
    <div className="map">
      <MapContainer
        center={[lat, lng]}
        zoom={11}
        scrollWheelZoom={false}
        className="size-303"
        style={{ height: "350px", width: "100%" }}
      >
        {/* Map tiles */}
        <TileLayer url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" />

        {/* Marker */}
        <Marker position={[lat, lng]} icon={customIcon}>
          <Popup>We are here!</Popup>
        </Marker>
      </MapContainer>
    </div>
  );
};

export default MapView;